import { Box, Stack, Typography } from '@mui/material';
import type { FC } from 'react';
import { Outlet } from 'react-router-dom';
import AuthImage from '~/assets/images/auth-image.jpg';
import Illustration1 from '~/assets/svgs/illustration-1.svg';
import LeafioLogoAlt from '~/assets/svgs/leafio-logo-alt.svg';
import { CSPHelmet } from '~/components/utilities/CSPHelmet';
import { useTrackingProviders } from '~/hooks/useTrackingProviders';

export const UnauthenticatedLayout: FC = () => {
  useTrackingProviders();

  return (
    <>
      <CSPHelmet />

      <Stack
        minHeight="100dvh"
        direction={{ md: 'row-reverse' }}
        justifyContent={{ xs: 'center', md: 'unset' }}
        spacing={{ xs: 8.75, md: 0 }}
      >
        <Stack
          spacing={6}
          pt={{ xs: 8 }}
          px={{ xs: 3 }}
          width={{ md: '55.83%' }}
          justifyContent="center"
          data-testid="content-column"
        >
          <Stack spacing={6} alignItems="center">
            <Box component="img" src={Illustration1} alt="Illustration" width={{ xs: 132, md: 156 }} />
            <Box component="img" src={LeafioLogoAlt} alt="Leafio" width={150} />
          </Stack>

          <Outlet />
        </Stack>

        <Stack
          flex={{ md: 1 }}
          sx={{
            background: { md: `url(${AuthImage}) no-repeat center center/cover` },
          }}
          color={{ md: 'primary.contrastText' }}
          textAlign={{ xs: 'center', md: 'left' }}
          justifyContent="flex-end"
          px={{ md: 10.75 }}
          pb={{ md: 3.75 }}
          position="relative"
          data-testid="image-column"
        >
          <Box
            display={{ xs: 'none', md: 'block' }}
            position="absolute"
            bottom={0}
            left={0}
            right={0}
            height={448}
            width="100%"
            sx={{
              background: 'linear-gradient(180deg, rgba(24, 24, 24, 0) 0%, rgba(20, 20, 20, 1) 100%)',
            }}
          />

          <Stack spacing={{ md: 10.5 }} position="relative" zIndex={1} px={{ xs: 2.5, md: 0 }}>
            <Typography
              component="h2"
              variant="h5"
              display={{ xs: 'none', md: 'block' }}
              pr={9.5}
              data-testid="image-column-title"
            >
              Our supplier&apos;s hub for managing Medical Cannabis prescriptions
            </Typography>

            <Typography component="p" variant="caption" data-testid="image-column-copyright">
              Copyrights Reserved Leafio Support: 03 7003 8214 or support@leafio.com
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </>
  );
};
